// import axios from 'axios';
import instanceAxios, {
  jwtAxiosFormData as instanceAxiosFormData,
} from '../@crema/services/auth/jwt-auth/jwt-api';

export const ROUTES = {
  //---------------------rate class
  RATE_CLASS_BY_ID: '/rateclass/getbyid',
  RATE_CLASS_LIST: '/rateclass/list',
  RATE_CLASS: '/rateclass',
  RATE_CLASS_CUSTOMIZE: '/rateclasscustomize',
  RATE_CLASS_CUSTOMIZE_LIST: '/rateclasscustomize/list',
  //---------------------pricing
  PRICING: '/pricing',
  PRICING_PER_UNIT: '/pricing/perunit',
  PRICING_RATE_CLASS: '/pricing/rateclass',
  //---------------------AWB
  AWB_CALCULATE: '/awb/calculate', //?????
  AWB: '/awb',
  INSERT_AWB: '/awb',
  UPDATE_AWB: '/awb/update',
  AWB_LIST: '/awb/list',
  AWB_RECIEPT_BY_ID: '/awb/select-reciept',
  AWB_POST_CHECK: '/awb/check-reciept',
  PRINT_DATA_CCA: '/awbcca/print',
  PAYMENT_METHODS: '/EnumPaymentMethod',
  PAYMENT_METHODSTYPES: '/enumPaymentMethod',
  ACCOUNT_TYPES: '/BankAccount',
  ACCOUNTING_RECEIPT: '/AccountingReceipt',
  ACCOUNTING_RESUBMIT: '/AccountingReceipt/resubmit',
  MEDIA: '/media/save-file',
  MEDIA_ACCESS: '/MediaAccess/AccessOrder',
  MEDIA_ACCESS_SHOW: '/MediaAccess/ShowFile', // get access and show in new tab
  MEDIA_SHOW: '/media/show-file',
  AWB_SELECT_BY_ID: '/awb/getbyid',
  PRINT_DATA: '/awb/print',
  AWB_PREVIEW: '/awb/preview',
  CCA_AWB: '/awbcca/insert',
  ISSUED_DRAFT_TEMP_LIST: '/awb/select-issued-temp-draft',
  //--------------------- pc pos
  PCPOS_TERMINAL_LIST: '/pcpos/list-of-terminals',
  PCPOS_INQUERY_PAYMENT: '/pcpos/inquery-payment', //?paymentid={id}
  PCPOS_INSERT_OR_UPDATE: '/awb',
  PCPOS_INSERT_OR_UPDATE_CCA: '/awbcca/insert',
  //---------------------cargoCost
  CURRENCY: '/pricing/perunit',
  CURRENCY_WITH_REQUIRED: '/currency',
  COST: '/enumairlinecost',
  CARGO_COST: '/airlinecost',

  //---------------------handling service cost
  HANDLING_CARGO_COST: '/handlingservicecost',
  HANDLING_CARGO_COST_LIST: '/handlingservicecost/list',
  HANDLING_CARGO_COST_BY_ID: '/handlingservicecost/getbyid',
  HANDLING_LIST: '/owner/3',
  //---------------------issuer awb
  ISSUER_AWB: '/issuerawb',
  //---------------------airport
  AIRPORT_SELECT: '/airport',
  AIRPORT_SELECT_BY_ID: '/airport/getbyid',
  AIRPORT_SAVE_CHANGE: '/airport',
  //---------------------routes
  ORIGIN_DESTINATION: '/OriginDestination',
  //---------------------routes
  ROUTE: '/route',
  //---------------------dashboard
  AWB_RATE_CLASS_STATISTICS: '/AwbRateClass',
  AWB_USER: '/AwbUser',
  AWB_REFUND_LIST: '/Awb/get-refund',
  AWB_REFUND: '/Awb/insert-refund',
  AWB_SALES_STATISTICS: '/AwbSalesStatistics',
  AWB_CARGO_TYPE: '/chart/cargo-type',
  DATE_MONTH: '/chart/date-month',
  DATE_YEAR: '/chart/date-year',
  //---------------------user
  USER_LIST: '/user/list',
  ROLE_LIST: '/role/list',
  OWNER_LIST: '/owner',
  USER_TYPE_LIST: '/enumusertype',
  USER_ADD_UPDATE: '/user/insert-or-update',
  USER_DELETE: '/user',
  USER_SELECT: '/user/getbyid',
  USER_CREDIT: '/user/credit',
  USER_USER_ACCESS: '/UserAccessToOtherAWBID/list',
  //---------------------role
  ROLE_ADD_UPDATE: '/role/insert-or-update',
  ROLE_SELECT: '/role/getbyid',
  ROLE_DELETE: '/Role/delete',
  //---------------------level
  LEVEL_LIST: '/level/list',
  LEVEL_ADD_UPDATE: '/level/insert-or-update',
  LEVEL_SELECT: '/level/getbyid',
  LEVEL_DELETE: '/Level/delete',
  FORM_LIST: '/form/list',
  //---------------------others
  ENUM_SERVICES: '/enumservice',
  LANGUAGE: '/language',
  CITY: '/city',
  WORLD: '/world',
  COUNTRY: '/country',
  SPECIAL_CARGO_TYPE: '/specialcargocode',
  GOOD_TYPE: '/goodtype',
  AIRPORT: '/airport',
  AUTH: '/authentication',
  //---------------------history
  RECEIPT_HISTORY_LIST: '/awb/select-reciept-history',
  RECEIPT_HISTORY_SELECT: '/awb/select-reciept',
  RECEIPT_DELETE: '/AccountingReceipt',
  AWB_HISTORY_LIST: '/awb/select-history',
  //---------------------transactions
  TRANSACTIONS_LIST: '/transaction/list',
  //---------------------return money
  RETURN_MONEY_LIST: '/RefundOrVoid/return-money-list',
  RETURN_MONEY_BY_ID: '/RefundOrVoid/return-money-get-by-id',
  POST_RETURN_MONEY: '/RefundOrVoid/return-money-paid',
  //-------------------- forget pass
  CHECK_USER: '/forgetpassword/check-user',
  SEND_SMS: '/forgetpassword/send-sms',
  CHECK_FORGETPASSWORD_CODE: '/forgetpassword/check-forgetpassword-code',
  UPDATE_PASSWORD: '/forgetpassword/update-password',
  //-------------------- report
  PAYMENT_STATUS: '/enumPaymentStatus',
  GET_REPORT_LIST: '/Report/general',
  GET_TRANSACTION_TYPE: '/EnumTransactionType/list',
  GET_AWB_STATUS_TYPE: '/EnumAWBStatus/list',
  GET_RETURN_MONEY_TYPE: '/EnumRequestType/list',
  //-------------------- Void
  VOID_OR_REFUND_FOR_CONFIRMATION: '/awb/select-to-confirm-void',
  VOID_OR_REFUND_CONFIRMATION_OR_REJECT:
    '/RefundOrVoid/request-confirm-or-reject',
};

const _get = (path: string, cb: (err: string | null, data: any) => void) => {
  instanceAxios
    .get(path)
    .then((res) => {
      const data = res.data;
      cb(null, data);
    })
    .catch((err) => {
      cb(err.message, err?.response?.data);
    });
};

const _getWithParams = (
  path: string,
  params: any,
  cb: (err: string | null, data: any) => void,
) => {
  instanceAxios
    .get(path, {params})
    .then((res) => {
      const data = res.data;
      cb(null, data);
    })
    .catch((err) => {
      cb(err.message, null);
    });
};

const _post = (
  path: string,
  param: any,
  cb: (err: string | null, data: any) => void,
) => {
  instanceAxios
    .post(path, param)
    .then((res) => {
      const data = res.data;
      cb(null, data);
    })
    .catch((err) => {
      cb(err.message, err?.response?.data);
    });
};

const _put = (
  path: string,
  param: any,
  cb: (err: string | null, data: any) => void,
) => {
  instanceAxios
    .put(path, param)
    .then((res) => {
      const data = res.data;
      cb(null, data);
    })
    .catch((err) => {
      cb(err, err?.response?.data);
    });
};

const _patch = (
  path: string,
  param: any,
  cb: (err: string | null, data: any) => void,
) => {
  instanceAxios
    .patch(path, param)
    .then((res) => {
      const data = res.data;
      cb(null, data);
    })
    .catch((err) => {
      cb(err, err?.response?.data);
    });
};

const _delete = (
  path: string,
  param: any,
  cb: (err: string | null, data: any) => void,
) => {
  instanceAxios
    .delete(path, {data: param})
    .then((res) => {
      const data = res.data;
      cb(null, data);
    })
    .catch((err) => {
      cb(err, err?.response?.data);
    });
};

const _upload = (
  path: string,
  param: any,
  cb: (err: string | null, data: any) => void,
) => {
  instanceAxiosFormData
    .post(path, param)
    .then((res: any) => {
      const data = res.data;
      if (cb) cb(null, data);
    })
    .catch((err: any) => {
      if (cb) cb(err, err?.response?.data);
    });
};

const api = {
  get: _get,
  getWithParams: _getWithParams,
  post: _post,
  put: _put,
  patch: _patch,
  delete: _delete,
  upload: _upload,
};

export default api;
